module.exports = __webpack_public_path__ + "static/img/partner-logo10.f6296fbe.jpg";